import { Component, Input, OnInit } from '@angular/core';
import { CommonModule } from '@angular/common';

@Component({
	selector: 'app-card-placeholder',
	templateUrl: 'card-placeholder.component.html',
	styleUrl: 'card-placeholder.component.scss',
	standalone: true,
	imports: [CommonModule]
})
export class CardPlaceholderComponent implements OnInit {
	@Input() hasHeader: boolean = false;
	@Input() hasFooter: boolean = false;
	@Input() hasTitle: boolean = false;
	@Input() hasSubTitle: boolean = false;
	@Input() bodyRowItemCounts: number[][] = [];
	@Input() listItemCount: number = 0;
	@Input() twoLineItems: boolean = true;
	@Input() class?: string;

	getNumbersArray(length: number) {
		return Array.from({ length: length }, (v, k) => k);
	}

	getRowItemPlaceholderWidth(index: number, ratio: number = 1.0) {
		// if (this.bodyRowItemCounts && this.bodyRowItemCounts.length > index) {
		// 	return `width: ${Math.round(1 / this.bodyRowItemCounts[index] * 100.0 * ratio)}%`;
		// }
		// return 'width: 100%';

		return `width: ${Math.round(100.0 * ratio)}%`;
	}

	ngOnInit() {
	}
}
